import { UnPublishedWinnerProps } from "./types";
import { COMPETITION_TYPE_DEFAULT_IMAGE } from "./winners-constants";

const UnPublishedWinner = ({ placeholderWinnerImageUrl, competitionType, position }: UnPublishedWinnerProps) => {
  const imageUrl = placeholderWinnerImageUrl
    ? placeholderWinnerImageUrl
    : `/assets/images/${
        COMPETITION_TYPE_DEFAULT_IMAGE[competitionType as keyof typeof COMPETITION_TYPE_DEFAULT_IMAGE]
      }`;
  return (
    <img
      src={imageUrl}
      alt={"winner-yet-to-be-decided"}
      loading={position === 0 || position === 1 ? "eager" : "lazy"}
      className="h-auto max-w-full border-[3px] border-solid border-[#e7e7e7]"
    />
  );
};

export default UnPublishedWinner;
